import jsonParse from "web/utils/data/parser/string/jsonParse";

import { IBankItem } from "web/types/Banks";
import { IPaymentSettingsItem } from "web/types/Payment";

import getActivePaymentSettings from "./getActivePaymentSettings";
import {
  ProductToSeparate,
  ProductToSeparateWithPaymentSettings,
} from "./types";

const getProductsWithActivePaymentSettings = (
  products: ProductToSeparate[],
  banks: IBankItem[]
): ProductToSeparateWithPaymentSettings[] =>
  products.map(({ payment_settings: paymentSettings, ...rest }) => {
    const paymentSettingsParsed =
      typeof paymentSettings === "string"
        ? jsonParse<IPaymentSettingsItem[]>(paymentSettings)
        : paymentSettings;

    const paymentSettingsActive = getActivePaymentSettings(
      paymentSettingsParsed,
      banks
    );

    return {
      ...rest,
      paymentSettings: paymentSettingsActive,
    } as ProductToSeparateWithPaymentSettings;
  });

export default getProductsWithActivePaymentSettings;
